import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs';
import { NIGHTWEB_APP_CONSTANT } from '../../constants';
import { AdminService, DataService, RoleService } from '../../services';
import { NightwebUtil } from '../../utils';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    standalone: false
})
export class MyProfileComponent implements OnInit {

  loading: boolean = false;
  submitted: boolean = false;
  phoneMask = NIGHTWEB_APP_CONSTANT.phoneMask;
  skeletonTheme = NIGHTWEB_APP_CONSTANT.skeletonLoaderConfig;
  user!: any;
  isAdvocate: boolean = false;
  isLoggedInEndUser: boolean = false;

  constructor(
    private dataService: DataService,
    private adminService: AdminService,
    private _roleService: RoleService,
    private nightwebUtil: NightwebUtil
  ) { }

  ngOnInit(): void {
    this.isLoggedInEndUser = this.nightwebUtil.isEndUser();
    this.getProfileInformation();

    this.dataService.getData().subscribe(
      (data) => {
        if (data) {
          this.getProfileInformation();
        }
      }
    )
  }

  getProfileInformation() {
    if (this.isLoggedInEndUser) {
      this.setEndUserProfileFromSession();
      return;
    }

    this.loading = true;
    this.adminService.getSelf()
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: (response) => {
          this.user = response.data;
          !this.user.superRoleId && this.getAllRoles();
        },
        error: (e) => {
        }
      })
  }

  private setEndUserProfileFromSession() {
    const plainUser = this.nightwebUtil.getPlainUser();
    const decoded = this.nightwebUtil.decodeToken(this.nightwebUtil.getLoggedInUser());
    const name = plainUser?.name || decoded?.name || '';
    const email = plainUser?.userName || decoded?.userName || '';
    this.user = {
      demographic: {
        firstName: name,
        middleName: '',
        lastName: '',
        email
      }
    };
    this.loading = false;
  }

  getAllRoles() {
    this._roleService.getAllRoles()
      .pipe()
      .subscribe({
        next: response => {
          const roles = response.data.rows;
          const advocateRole = roles.find((role: any) => role.code === NIGHTWEB_APP_CONSTANT.roles.ADVOCATE);
          this.isAdvocate = this.user.organizations[0].roleId === advocateRole.id;
        },
        error: error => console.log('error getting roles', error)
      });
  }
}
